import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-menu-details",
  templateUrl: "./menu-details.component.html",
  styleUrls: ["./menu-details.component.css"],
})
export class MenuDetailsComponent implements OnInit {
  menus: any;
  viewType: any;

  constructor(private route: ActivatedRoute) {}

  @Input() settings: any;
  @Input() data: any;

  view: any = {};

  ngOnInit() {
    this.view = {
      content: "content",
      additionalContent: "additionalContent",
      title: "title",
      image: "image",
    };
    this.viewType = 2;

    if (this.route.snapshot.data.data && this.route.snapshot.data.data[0]) {
      this.view = this.route.snapshot.data.data[0];
      this.viewType = this.route.snapshot.data.type;

      //  for old hemmah old build
      if (this.viewType == 1 && this.view.settingsBody && this.view.page)
        this.view = this.view.page;
    }

    //   this.view = this.viewType == 2 ? this.view : this.view.page
    this.view.content =
      this.viewType == 2 ? this.view.content : this.view.additionalContent;

    if (
      this.data.moduleService.site.HostName &&
      this.data.moduleService.site.HostName != ""
    ) {
      const replaceWith =
        'href="/' +
        decodeURIComponent(this.data.moduleService.site.HostName) +
        "/";
      if (this.view.content && this.view.content.includes("href")) {
        this.view.content = this.view.content
          .split('href="/')
          .join(replaceWith);
      }
    }

    this.view.title = this.viewType == 2 ? this.view.title : this.view.name;
    this.view.description =
      this.viewType == 2 ? this.view.description : this.view.description;
  }
}
